import Layout from '../../components/layout/layout.component';

const Navigation = () => {
    return <Layout />;
};

export default Navigation;
